import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Grid,
	Tooltip
} from '@material-ui/core';

import CircledIconButton from "./CircledIconButton";

const styles = makeStyles(theme => ({
	tooltip: {
		maxWidth: 130
	}
}));

function PatternActions(props) {
	let classes = styles(),
		primaryActions = [],
		{actions} = props;

	if (actions && actions.length) {
		actions.map((action, index) => {
			let button = (
				<CircledIconButton
					text={action.label}
					color={action.color}
					disabled={action.disabled}
					onClick={e => action.handleClick(e)}
					aria-label={`${action.label} Pattern`}>
					<FontAwesomeIcon
						size="xs"
						icon={action.icon}
						rotation={action.iconRotation}
						title={`${action.label} Pattern`} />
				</CircledIconButton>
			);

			return (
				primaryActions.push(
					<Grid item key={action.label}>
						{action.tooltip && !action.disabled ?
							<Tooltip
								placement="top"
								disableFocusListener
								title={action.tooltip}
								classes={{tooltip: classes.tooltip}}>
								{button}
							</Tooltip> : button
						}
					</Grid>
				)
			);
		});
	}

	return (
		<Grid
			container
			direction="row"
			justify="space-evenly">
			{primaryActions}
		</Grid>
	);
}

PatternActions.propTypes = {
	actions: PropTypes.array
};

export default PatternActions;
